//import axios from 'axios'
import axios from './axiosConfig'

export default {
    /*
        GET     axios.get('https://heliosselect.de/de/get/productdata',{ params: { unit_types_id: 100 } })
    
    getProductdata: function () {
        return axios.get('get/productdata');
    },
    */
    async getProductdata(params_data) {
        /* return axios.get('https://heliosselect.de/de/get/product', { params: { refno: prodrefno} })
            .then(response => {
                return response.data;
            }); */
        //--return axios.get('https://heliosselect.de/de/get/product', { params: { refno: params_data } });
        //--return axios.post('https://heliosselect.de/de/get/product', params_data);
        
        return axios.post('/api/get/product', params_data);
    
    },
    async getProductMediadata(params_data) {
        return axios.post('/api/get/productmedia', params_data);
    },
    async getProductCurves(params_data) {
        return axios.post('/api/get/productcurves', params_data);
    },
    async getProductAccessories(params_data) {
        return axios.post('/api/get/productaccessories', params_data);
    },
    async getProductParents(params_data) {
        return axios.post('/api/get/productparents', params_data);
    },
   /*  async getProductAcoustics(params_data) {
        return axios.post('/api/get/productacoustics', params_data);
    }, */
    async getProductInfo(params_data) {
        return axios.post('/api/get/productinfo', params_data);
    },
    async getProductCadenas(params_data) {
        return axios.post('/api/get/cadenas', params_data);
    },




    
    

   /*  async getProductLVText(params_data) {
        return axios.get('/mediadata/product/datanorm/' + params_data);

    } */
        

  
}
